// extracted by mini-css-extract-plugin
export var copyableItem = "_b-0";
export var underlined = "_b-1";